// extracted by css-extract-rspack-plugin
export default {"item":"_536d137d","isSelected":"_2d44edb"};